import { useEffect, useState } from "react"
import ReservationPrice from "./ReservationPrice/ReservationPrice"
import useHttp from "../../../../hooks/use-http"
import KeyValueTable from "../../../../UI/KeyValueTable/KeyValueTable"
import { datetimeFormatter, euroFormatter } from "../../../../functions/Formatters/formatters"
import i18n from "../../../../i18n"
import FormBlock from "../../../../components/Form/FormBlock"
import Icon from "../../../../icons/Icon"


const ReservationOverview = ({ initialReservation = null, initialOptionsForm = null }) => {

    const [reservationData, setReservationData] = useState(initialReservation)
    const [reload, setReload] = useState(!initialReservation)
    const [addDiscountCoupon, setAddDiscountCoupon] = useState(false)
    const {isLoading : getFormLoading, error : getFormError, sendRequest : getData} = useHttp((data) => {setReservationData(data)})

    useEffect(() => {  
        if(reload){
            getData({url:'/rest/reservation/current/retrieve_store/', json:true})
            setReload(false)
        }
    }, [reload])  

    if(!reservationData){
        return <div></div>
    }

    const table_fields = {
        'full_name': i18n.t('Name'),
        'company': i18n.t('Company'),
        'quantity': i18n.t('Quantity'), 
        'people': i18n.t('People'),
        'email': i18n.t('Email'),
        'phone': i18n.t('Phone'), 
    }
    const addition_fields = <>
        {reservationData.payment_method_object &&
        <tr>
            <td>{i18n.t('Payment method')}</td>
            <td>{reservationData.payment_method_object.name}</td>
        </tr>
        }
        <tr>
            <td>{i18n.t('Start time')}</td>
            <td>{datetimeFormatter(reservationData.from_time)}</td>
        </tr>   
        <tr>
            <td>{i18n.t('End time')}</td>
            <td>{datetimeFormatter(reservationData.to_time)}</td>
        </tr>
        <tr>
            <td>{i18n.t('Total time')}</td>
            <td>{reservationData.duration_rounded}</td>
        </tr>
    </> 
    return <div className="container">
        <div className="w-100 row my-4">
            <div className="col-12 col-md-4">
                <KeyValueTable original={reservationData} allowed={table_fields} >
                    {addition_fields}
                </KeyValueTable>
            </div>
            <div className="col-12 col-md-8">
                <ReservationPrice data={reservationData}/>
                <div className="d-flex justify-content-end align-items-center mt-2">
                    <a className="text-dark p-1" type="button" onClick={()=>setAddDiscountCoupon(true)}><Icon name="ICON_PLUS" /> {i18n.t('Add discount coupon')}</a>
                </div>
                {addDiscountCoupon &&
                <div className="col-12 col-md-8 ms-auto d-flex justify-content-end">
                    <FormBlock url={`/rest/reservation/current/add_discount_coupon/`} saveHook={()=>setReload(true)} inline={true} />
                </div>
                }
            </div>
            <div className="col-12 col-md-8">
            </div>
            <div className="justify-content-center align-items-end mt-3 ms-auto col-12 col-md-8" >
                    <FormBlock url={`/rest/reservation/current/add_options/`} initialData={initialOptionsForm} saveHook={()=>setReload(true)}  />
            </div>
            {  reservationData.deposit_amount && (reservationData.deposit_amount !=  (reservationData.total_amount_in_vat ?? reservationData.calc_total_amount_in_vat ?? reservationData.total_amount))?
                <div className="justify-content-center mt-3 ms-auto col-12 col-md-8 alert alert-warning" >
                    <i className="bi bi-info-circle me-2"/>
                    {i18n.t('You only need to pay a deposit to confirm the booking:')} {euroFormatter(reservationData.deposit_amount)}
                </div>
            :null
            }
            {reservationData.reservation_errors?.length > 0 &&
                <div className="justify-content-center mt-3 ms-auto col-12 col-md-8 alert alert-danger" >
                    <i className="bi bi-info-circle me-2"/>
                    {reservationData.reservation_errors.map(error => <div key={error}>{error}</div>)}
                </div>
            }
            <div className="col-12 d-flex justify-content-end align-items-center mt-5">
                <a href="/rest/reservation/current/cancel_reservation/" className="border-2 smr-btn px-2 py-1 me-5" style={{color: 'var(--smr-danger)'}}>{i18n.t('Cancel')}</a>
            </div>
        </div>
    </div>
}

export default ReservationOverview